import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ConfirmDialogComponent } from '@shared/ui/overlay/confirm/confirm-dialog.component';

@Component({
  selector: 'dros-root',
  standalone: true,
  imports: [RouterOutlet, ConfirmDialogComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./app.component.html",
})
export class AppComponent {}
